/* eslint complexity: ["error", 9] */
import { useEffect, useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import { Button, HelperText } from '@cof/plastic-components';
import { useLandmarkRefsContext } from '../../../components/LandmarkRefsProvider';

export const shouldDisplayFormTick = (id: any, getValues: any, errors: any) => {
    const value = getValues(id);
    return !!(value && value.length > 0 && !errors[id]);
};

export const shouldDisplayRadioTick = (id: any, watch: any, errors: any, getFieldState: any, getValues: any) => {
    const value = watch(id);
    if (getFieldState) {
        const value2 = getValues(id);
        const fieldState = getFieldState(id);
        return !fieldState?.invalid && value2;
    }
    return !!(value && !errors[id]);
};

let showErrors = false;

export const setShowErrors = (show: any) => {
    showErrors = show;
};

export const getShowErrors = () => {
    return showErrors;
};

const ErrorHandler = ({ id, show = false, onClick, fieldRef: externalFieldRef, ariaRole }: any) => {
    const {
        formState: { errors }
    } = useFormContext();
    // @ts-expect-error TS2339: Property 'registerFieldError' does not exist on type ''.
    const { registerFieldError, unregisterFieldError } = useLandmarkRefsContext();
    const internalFieldRef = useRef(null);
    const fieldRef = externalFieldRef || internalFieldRef;

    if (getShowErrors()) {
        show = true;
    }

    const error = errors[id];
    const errorMessage = error?.message;

    useEffect(() => {
        if (errorMessage) {
            if (!externalFieldRef) {
                // @ts-expect-error TS2322: Type 'Element | null' is not assignable to type 'null'.
                internalFieldRef.current = document.getElementById(id) || document.querySelector(`input[name="${id}"]`);
            }
            registerFieldError({ id, errorMessage, fieldRef });
        }
        return () => unregisterFieldError({ id });
    }, [errorMessage, id]); // eslint-disable-line react-hooks/exhaustive-deps

    if (!show || !error) return null;
    if (!errorMessage) return null;

    return (
        <HelperText
            variant="error"
            id={`${id}-error-message`}
            data-qa-id={`${id}-validation-messages`}
            data-qm-allow
            role={ariaRole}
        >
            {/* @ts-expect-error TS2322: Type 'string | Element | FieldError | Merge<FieldError, FieldErrorsImpl<any>>' is not assignable to  */}
            {onClick ? (
                <Button
                    variant="textLink"
                    p={0}
                    minWidth={0}
                    onClick={onClick}
                    style={{
                        color: 'inherit',
                        fontWeight: 'inherit',
                        fontSize: 'inherit',
                        marginTop: '-2px'
                    }}
                >
                    {/* @ts-expect-error TS2322: Type 'string | FieldError | Merge<FieldError, FieldErrorsImpl<any>>' is not assignable to type '((st */}
                    {errorMessage}
                </Button>
            ) : (
                errorMessage
            )}
        </HelperText>
    );
};

ErrorHandler.propTypes = {
    id: PropTypes.string.isRequired,
    show: PropTypes.bool,
    onClick: PropTypes.func,
    fieldRef: PropTypes.shape({
        current: PropTypes.any
    }),
    ariaRole: PropTypes.string
};

export default ErrorHandler;
